// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2ncU4","log":"ModalInventoryLogs_log__271MK","date":"ModalInventoryLogs_date__3lCib","userName":"ModalInventoryLogs_userName__3BWAs"};